import React, { useEffect, useState } from 'react'
import purchasesumStyle from './PurchaseSummaryPage.module.css'
import ParentsHeader from '../../components/Header/ParentsHeader'
import BackBar from '../../components/BackBar/BackBar'
import SideBar from '../../components/Sidebar/SideBar'
import { useMediaQuery } from 'react-responsive';
import bookss from '../../../assets/images/books.png'
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
require('typeface-poppins');


export default function PurchaseSummaryPage() {
    const { order_number } = useParams();
    const [orderData, setOrderData] = useState(null);
    const [orderDataItem, setOrderDataItem] = useState(null);
    const order = orderData?.[0];

    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_all_orders.php?order_number=${order_number}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setOrderData(data.order);
                    setOrderDataItem(data.order_items);
                }
            });
    }, [order_number]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            month: 'short',   // Nov
            day: '2-digit',   // 30
            year: 'numeric',  // 2025
        });
    };
    // const location = useLocation();
    // const { orderData, cartItems } = location.state || {};
    // console.log(orderData,'orderdata');
    /*const purchaseDate = new Date().toLocaleDateString();
    const subtotal = cartItems?.reduce((sum, item) => sum + item.price * item.quantity, 0) || 0;
    const tax = (subtotal * 0.00).toFixed(2); // Example: 7% tax
    const grandTotal = (subtotal + parseFloat(tax)).toFixed(2);*/
    //const { orderData, cartItems } = location.state || {};

    return (
        <>
            <ParentsHeader />
            <div className={purchasesumStyle.purchasesummaryPage}>
                <div className='container'>
                    <div className='row mb-4'>
                        <div className='col-xl-12'>
                            <BackBar />
                        </div>
                    </div>
                    <div className='row'>
                        {isMobile ? (
                            undefined
                        ) : (
                            <div className='col' style={{ maxWidth: '275px' }}>
                                <SideBar />
                            </div>
                        )}

                        {isMobile ? (
                            <div className='col'>
                                <div className={purchasesumStyle.mobilpurchasesummaryContainer}>
                                    <div className={purchasesumStyle.mobilpostitles}>
                                        <h2>Purchase Summary</h2>
                                        <p> <strong className='me-2'> Purchase Date </strong>
                                            <span> 00/00/0000 </span>
                                        </p>
                                    </div>
                                    <div className='row g-2 mb-4'>
                                        <div className='col-4'>
                                            <div className={purchasesumStyle.mobilpspImg}>
                                                <img src={bookss} className='img-fluid w-100' />
                                            </div>
                                        </div>
                                        <div className='col-8'>
                                            <div className={`${purchasesumStyle.mobilpspContent} d-flex flex-column h-100 justify-content-between`}>
                                                <div>
                                                    <h4> Brown Bear, Brown Bear. What Do You See? </h4>
                                                </div>
                                                <div className='d-flex justify-content-between'>
                                                    <div className={`${purchasesumStyle.mobilqtyText} text-center`}>
                                                        <p> Qty: </p>
                                                        <span> 1 </span>
                                                    </div>
                                                    <div className={`${purchasesumStyle.mobilqtyText} text-center`}>
                                                        <p> Price </p>
                                                        <span> $17.99 </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={purchasesumStyle.incriptionDatas}>
                                        <h4> Inscription Details </h4>
                                        <div className={purchasesumStyle.incriptionDataInner}>
                                            <div className={`${purchasesumStyle.incriptionDataleft} w-50`}>
                                                <h6> Enter inscription name </h6>
                                            </div>
                                            <div className={`${purchasesumStyle.incriptionDataright} w-50 text-end`}>
                                                <p> James </p>
                                            </div>
                                        </div>
                                        <div className={purchasesumStyle.incriptionDataInner}>
                                            <div className={`${purchasesumStyle.incriptionDataleft} w-50`}>
                                                <h6> Enter student full name </h6>
                                            </div>
                                            <div className={`${purchasesumStyle.incriptionDataright} w-50 text-end`}>
                                                <p> James Lindo </p>
                                            </div>
                                        </div>
                                        <div className={purchasesumStyle.incriptionDataInner}>
                                            <div className={`${purchasesumStyle.incriptionDataleft} w-50`}>
                                                <h6> Enter Teachers name </h6>
                                            </div>
                                            <div className={`${purchasesumStyle.incriptionDataright} w-50 text-end`}>
                                                <p> Mrs. Smith </p>
                                            </div>
                                        </div>
                                        <div className={purchasesumStyle.incriptionDataInner}>
                                            <div className={`${purchasesumStyle.incriptionDataleft} w-50`}>
                                                <h6> Grade level </h6>
                                            </div>
                                            <div className={`${purchasesumStyle.incriptionDataright} w-50 text-end`}>
                                                <p> 3 </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={purchasesumStyle.ordersumDatas}>
                                        <h4> Order Summary </h4>
                                        <div className={purchasesumStyle.ordersumDataInner}>
                                            <div className={`${purchasesumStyle.ordersumDataleft} w-50`}>
                                                <h6> Subtotal </h6>
                                            </div>
                                            <div className={`${purchasesumStyle.ordersumDataright} w-50 text-end`}>
                                                <p> $00.00 </p>
                                            </div>
                                        </div>
                                        <div className={purchasesumStyle.ordersumDataInner}>
                                            <div className={`${purchasesumStyle.ordersumDataleft} w-50`}>
                                                <h6> Tax </h6>
                                            </div>
                                            <div className={`${purchasesumStyle.ordersumDataright} w-50 text-end`}>
                                                <p> $00.00 </p>
                                            </div>
                                        </div>
                                        <div className={purchasesumStyle.ordersumDataInner}>
                                            <div className={`${purchasesumStyle.ordersumDataleft} w-50`}>
                                                <h6> <strong> Grand Total </strong> </h6>
                                            </div>
                                            <div className={`${purchasesumStyle.ordersumDataright} w-50 text-end`}>
                                                <p> <strong> $00.00 </strong> </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={purchasesumStyle.parentsumDatas}>
                                        <h4> Parents Information </h4>
                                        <div className={purchasesumStyle.parentsumDataInner}>
                                            <div className={`${purchasesumStyle.parentsumDataleft} w-50`}>
                                                <h6> Parents Name </h6>
                                            </div>
                                            <div className={`${purchasesumStyle.parentsumDataright} w-50 text-end`}>
                                                <p> Mark Zuckerberg </p>
                                            </div>
                                        </div>
                                        <div className={purchasesumStyle.parentsumDataInner}>
                                            <div className={`${purchasesumStyle.parentsumDataleft} w-50`}>
                                                <h6> Parents Email </h6>
                                            </div>
                                            <div className={`${purchasesumStyle.parentsumDataright} w-50 text-end`}>
                                                <p> email@email.com </p>
                                            </div>
                                        </div>
                                        <div className={purchasesumStyle.parentsumDataInner}>
                                            <div className={`${purchasesumStyle.parentsumDataleft} w-50`}>
                                                <h6> Parents Phone </h6>
                                            </div>
                                            <div className={`${purchasesumStyle.parentsumDataright} w-50 text-end`}>
                                                <p> 000-000-0000 </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className='col'>
                                <div className={purchasesumStyle.purchasesummaryContainer}>
                                    <div className='row g-0'>
                                        <div className='col-sm-8'>
                                            <div className={purchasesumStyle.purchasesummaryWrapper}>
                                                <div className={purchasesumStyle.purchasesummaryInner} style={{ borderBottom: '1px solid #C1C1C1' }}>
                                                    <h4 className={purchasesumStyle.summaryTitle}>Purchase Summary</h4>
                                                    <div className='d-flex align-items-center pb-5'>
                                                        <h6 className='me-4'> Purchase Date: </h6>
                                                        {order?.order_date && formatDate(order.order_date)}
                                                    </div>
                                                    {orderDataItem && orderDataItem.length > 0 ? (
                                                        orderDataItem.map((items, index) => (
                                                            <div className='row' key={index}>
                                                                <div className='col-lg-3'>
                                                                    <div className={purchasesumStyle.summarybooksWrap}>
                                                                        <img src={`${process.env.REACT_APP_API_BASE_URL}authormeetapi/images/ProductImages/${items.isbn}.jpg`}
                                                                            alt={items.title} className='img-fluid mb-4' style={{ height: '179px' }} />
                                                                    </div>
                                                                </div>
                                                                <div className='col-lg-9'>
                                                                    <div className={purchasesumStyle.summaryDetailone}>
                                                                        <h4> {items.title} </h4>
                                                                        <p> Hard Cover </p>
                                                                        <h5> ${items.price} </h5>
                                                                        <h5> {items.quantity} </h5>
                                                                        <h6> <strong> Inscription Name: </strong> <span> {items.inscription_name} </span> </h6>
                                                                        <h6> <strong> Inscription Full Name: </strong> <span> {items.inscription_st_full_name} </span></h6>
                                                                        <h6> <strong> Teachers Name: </strong> <span> {items.inscription_teacher_name} </span></h6>
                                                                        <h6> <strong> Grade Level: </strong> <span>{items.inscription_grade_level} </span> </h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <p>No items found in this order.</p>
                                                    )}

                                                </div>

                                            </div>
                                        </div>
                                        <div className='col-sm-4'>
                                            <div className={purchasesumStyle.purchaseorderSummary}>
                                                <h4 className={purchasesumStyle.postitle}>Order Summary</h4>
                                                <div className={purchasesumStyle.possubboxone}>
                                                    <div className='d-flex'>
                                                        <h6>Subtotal:</h6>
                                                        <span className='ms-auto'>${order?.total_amount}</span>
                                                    </div>
                                                </div>
                                                <div className={purchasesumStyle.possubboxone}>
                                                    <div className='d-flex'>
                                                        <h6>Tax:</h6>
                                                        <span className='ms-auto'>${order?.tax}</span>
                                                    </div>
                                                </div>
                                                <div className={purchasesumStyle.possubboxtwo}>
                                                    <div className='d-flex'>
                                                        <h6>Grand Total:</h6>
                                                        <span className='ms-auto'>${order?.total_amount}</span>
                                                    </div>
                                                </div>
                                                <h5 className={purchasesumStyle.posInfoTitle}>Parents Information</h5>
                                                <div className={purchasesumStyle.posContent}>
                                                    <h5> {`${order?.first_name} ${order?.last_name}` || 'N/A'} </h5>
                                                    <h6> {order?.email || 'N/A'} </h6>
                                                    <p> {order?.phone || 'N/A'}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}
